module.exports = "/_next/static/images/6688d3fe619b78961e38bff2d6f8017d-credit-card-autonomy@1x.png";